import { z } from 'zod';
import { AliasType } from 'api/api';

export const aliasFormSchema = z.object({
  alias: z.string().min(1, 'Alias is required'),
  aliasType: z.nativeEnum(AliasType),
  entityPublicId: z.string().min(1, 'Entity is required'),
});

export type AliasFormSchema = z.infer<typeof aliasFormSchema>;
